import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
//
import { useSelector } from 'react-redux';

// ----------------------------------------------------------------------

export default function GuestGuard({ children }) {
  const router = useRouter();
  const { user } = useSelector((state) => state.user);

  const returnTo = user?.userType === 'super-admin' ? paths.superAdminDashboard.root : user?.userType   === 'user' ?
    // paths.dashboard.root
    '/'
    : paths.orangizerDashboard.root;

  const check = useCallback(() => {
    if (user?.token) {
      router.replace(returnTo);
    }
  }, [returnTo, router, user]);

  useEffect(() => {
    check();
  }, [check]);

  return <>{children}</>;
}

GuestGuard.propTypes = {
  children: PropTypes.node,
};
